import styled from '@emotion/styled';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useGetTenantBillingStat } from '@queryHooks/useTenantBillingStat';
import { AnalyzeElement } from './AnalyzeElement';

export const CostSummary = () => {
  const { t } = useTranslation();
  const { data: tenantBillingStat, isLoading } = useGetTenantBillingStat({ month: dayjs().format('YYYY-MM') });

  return (
    <Container>
      {isLoading ? (
        <>
          <AnalyzeElement.Skeleton title={t('Cost_Analysis.Annual_Payment_Estimate')} />
          <AnalyzeElement.Skeleton title={t('Cost_Analysis.Monthly_Payment_Estimate')} />
        </>
      ) : (
        <>
          <AnalyzeElement
            title={t('Cost_Analysis.Annual_Payment_Estimate')}
            value={tenantBillingStat?.annualPaymentEstimate ?? 0}
            criteria={t('Cost_Analysis.Year_Over_Year')}
            variations={0} // FIXME: API 필요
          />
          <AnalyzeElement
            title={t('Cost_Analysis.Monthly_Payment_Estimate')}
            value={tenantBillingStat?.monthlyPaymentEstimate ?? 0}
            criteria={t('Cost_Analysis.Month_Over_Month')}
            variations={tenantBillingStat?.monthlyPaymentEstimateGrowthRate ?? 0}
          />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 1px;
  background-color: ${({ theme: { colors } }) => colors['bg-gray-lighter']};
  border: 1px solid ${props => props.theme.colors['border-gray-dark']};
  border-radius: 5px;
  margin-bottom: 56px;
  overflow: hidden;
`;
